import helpers from './helpers';

function updateFeeText(bid, fee) {
  const bodkoppel = document.getElementById('bodkoppel');
  const bodfee = document.getElementById('bodfee');
  const { sameCountry } = document.getElementById('pickup_no').dataset;
  const vehicleType = document.getElementsByName('vehicleType')[0].value;
  let feeBack = bid - fee;

  if (feeBack < 0) {
    feeBack = 0;
  }

  bodfee.textContent = helpers.formatAmount(Math.round(fee));
  bodkoppel.textContent = helpers.formatAmount(Math.round(feeBack));

  if (document.getElementById('pickupvalue')) {
    const noButton = document.getElementById('nee');
    const yesButton = document.getElementById('ja');
    const minimalBid = vehicleType === 'motobike' ? 500 : 250;
    if (bid > minimalBid && parseInt(sameCountry, 10) === 1 && vehicleType !== 'bicycle') {
      noButton.removeAttribute('disabled');
      yesButton.removeAttribute('disabled');
      if (vehicleType === 'motobike') {
        document.getElementById('pickupvalue').value = 'true';
        noButton.classList.remove('pick-up__button--active');
        yesButton.classList.add('pick-up__button--active');
      } else {
        document.getElementById('pickupvalue').value = 'false';
        noButton.classList.add('pick-up__button--active');
        yesButton.classList.remove('pick-up__button--active');
      }
    } else {
      document.getElementById('pickupvalue').value = 'true';
      yesButton.setAttribute('disabled', 'true');
      yesButton.classList.add('pick-up__button--active');
      noButton.setAttribute('disabled', 'true');
      noButton.classList.remove('pick-up__button--active');
    }
  }
}

/**
 *
 * @param integer amount
 */
function findFeeNew(amount, vehicleType) {
  // do ajax call
  $.ajax({
    type: 'GET',
    url: '/fee',
    data: {
      bid: amount,
      vehicleType,
    },
  }).done((fee) => {
    updateFeeText(amount, fee);
  }).fail(() => {
    // fallback:
    const fee = Math.max(85, Math.round((124 * Math.log(amount) - 565) * 1.05));
    updateFeeText(amount, fee);
  });
}

/**
 * function to return fee to user when user types a bid in the input
 * for nl uses percentages. other countries use steps.

 */
function getHandlingfee(vehicleType) {
  const numberPattern = /[0-9]+/g;
  const amount = $('#bid').val();
  if (typeof amount !== 'undefined') {
    const numberContent = amount.match(numberPattern);
    const bid = parseFloat((numberContent).toString().replace(/,/g, ''));

    findFeeNew(bid, vehicleType);
  }
}

export default { getHandlingfee };
